/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 40 40" {...props}>
    <path
      fill="#2A62DB"
      d="M20 24.176c6.514 0 12.108 3.938 14.534 9.562A19.933 19.933 0 0 0 40 20C40 8.954 31.046 0 20 0S0 8.954 0 20a19.93 19.93 0 0 0 5.466 13.738c2.426-5.624 8.02-9.562 14.534-9.562Zm0-17.082a7.034 7.034 0 1 1 0 14.067 7.034 7.034 0 0 1 0-14.067Z"
    />
    <path
      fill="#EAEFFB"
      d="M26.498 16.82a7.034 7.034 0 1 0-12.997-5.383A7.034 7.034 0 0 0 26.5 16.821ZM20 40a19.941 19.941 0 0 0 14.534-6.262c-2.426-5.624-8.02-9.562-14.534-9.562-6.514 0-12.108 3.938-14.534 9.562A19.941 19.941 0 0 0 20 40Z"
    />
  </svg>
);

export default SvgUserAvatar;
